export const requiredMessage = 'Questo campo è obbligatorio!';
export const emailNotValid = 'Email non valida!';
export const passwordMisMatch = 'Le passwords non corrispondono!';
export const passwordRulesMisMatch = 'Password does not follow under written rules!';
export const phoneOnlyNumericals = 'Phone no. is invalid!';
export const noSpaceMessage = 'No spaces allowed';
